import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../App';

export const REGIME_STYLES = {
  company: 'bg-[#283F8B]/10 text-[#283F8B] border-[#283F8B]/20',
  sole_trader: 'bg-amber-500/10 text-amber-700 border-amber-500/20',
  partnership: 'bg-violet-500/10 text-violet-700 border-violet-500/20',
  nonprofit: 'bg-emerald-500/10 text-emerald-700 border-emerald-500/20',
  branch: 'bg-slate-500/10 text-slate-700 border-slate-500/20',
};

export function useLegalForm() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/business/legal-form`);
      setData(r.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  return { data, loading, refresh };
}

export function useLegalFormOptions(country) {
  const [options, setOptions] = useState(null);
  useEffect(() => {
    if (!country) { setOptions(null); return; }
    let live = true;
    axios.get(`${API}/business/legal-form/options`, { params: { country } })
      .then((r) => { if (live) setOptions(r.data); })
      .catch(() => { if (live) setOptions(null); });
    return () => { live = false; };
  }, [country]);
  return options;
}
